import { Component } from '@angular/core';

@Component({
  selector: 'richness-icon',
  standalone: true,
  imports: [],
  templateUrl: './richness.component.html',
  styleUrl: './richness.component.scss'
})
export class RichnessIcon {

}
